import { createStore } from "vuex";
import userStore from '@/store/modules/userStore';
import commonStore from '@/store/modules/commonStore';

export default createStore({
  modules: {
    userStore,
    commonStore,
  },
});
